module.exports = __webpack_public_path__ + "static/media/Visitenkarte.83cb6397.png";